import React from 'react';
import { Star, Trash2, Share2, FileText } from 'lucide-react';

export default function SavedReportsList({
  reports,
  onLoad,
  onDelete,
  onToggleFavorite,
  currentReportId,
}) {
  if (!reports || reports.length === 0) {
    return (
      <div className="saved-reports-empty">
        <FileText size={20} />
        <p>No saved reports yet</p>
      </div>
    );
  }

  const favorites = reports.filter(r => r.is_favorite);
  const others = reports.filter(r => !r.is_favorite);

  return (
    <div className="saved-reports-list">
      {favorites.length > 0 && (
        <>
          <div className="saved-reports-section-label">Favorites</div>
          {favorites.map(report => (
            <SavedReportItem
              key={report.id}
              report={report}
              isActive={report.id === currentReportId}
              onLoad={onLoad}
              onDelete={onDelete}
              onToggleFavorite={onToggleFavorite}
            />
          ))}
        </>
      )}
      {others.length > 0 && (
        <>
          {favorites.length > 0 && <div className="saved-reports-section-label">All Reports</div>}
          {others.map(report => (
            <SavedReportItem
              key={report.id}
              report={report}
              isActive={report.id === currentReportId}
              onLoad={onLoad}
              onDelete={onDelete}
              onToggleFavorite={onToggleFavorite}
            />
          ))}
        </>
      )}
    </div>
  );
}

function SavedReportItem({ report, isActive, onLoad, onDelete, onToggleFavorite }) {
  const typeLabels = { sales_pipeline: 'Pipeline', revenue: 'Revenue', forecast: 'Forecast' };

  return (
    <div
      className={`saved-report-item ${isActive ? 'active' : ''}`}
      onClick={() => onLoad(report)}
    >
      <div className="saved-report-item-content">
        <div className="saved-report-item-name">{report.name}</div>
        <div className="saved-report-item-meta">
          <span className="saved-report-type-badge">{typeLabels[report.report_type] || report.report_type}</span>
          {report.is_shared ? <Share2 size={12} /> : null}
        </div>
      </div>
      <div className="saved-report-item-actions">
        <button
          className="btn-icon btn-xs"
          onClick={(e) => { e.stopPropagation(); onToggleFavorite(report); }}
          title={report.is_favorite ? 'Remove from favorites' : 'Add to favorites'}
        >
          <Star size={14} fill={report.is_favorite ? 'var(--color-warning)' : 'none'} stroke={report.is_favorite ? 'var(--color-warning)' : 'currentColor'} />
        </button>
        <button
          className="btn-icon btn-xs"
          onClick={(e) => { e.stopPropagation(); onDelete(report); }}
          title="Delete report"
        >
          <Trash2 size={14} />
        </button>
      </div>
    </div>
  );
}
